module.exports = __webpack_public_path__ + "img/face-regular.5597d95f.svg";